import React from "react";
import "../css/404.css"
const NotFound = () => {
    return (
        <>
            <div className="four_o_four">
                <h1>404.</h1>

                <div className="four_o_four_text">
                    <p>The page you are looking for does not exist.🎈🎃</p>
                </div>
            </div>

        </>
    )
}

export default NotFound;